import styled from 'styled-components';
import { Typography } from '../../../global/theme';

const DescriptionInputSection = styled.div`
  .tiptap {
    max-height: 240px;
    min-height: 90px;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: block;
      background-color: var(--background-primary);
      width: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: var(--text-tertiary);
      width: 6px;
      margin-bottom: 4px;
      border-radius: var(--border-radius-6);
      min-height: 20px;
    }
  }
`;
const FileBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 0;
  padding: 0;
  margin-top: 8px;
`;

const DropFileDiv = styled.div`
  position: absolute;
  // top: 0;
  // left: 0;
  margin-top: -10px;
  width: calc(100% - 32px);
  // height: calc(100% - 32px);
  background: var(--background-secondary);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border: 1px dashed var(--border-secondary);
  border-radius: var(--border-radius-8);
  padding: 20px 16px 18px 16px;
  span {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }
`;

export { DescriptionInputSection, FileBox, DropFileDiv };
